import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { Page } from '@/components/Layout/Page/Page';
import { MinorReviewCompleteForm } from '@/components/PageForm/MinorReviewCompleteForm/MinorReviewCompleteForm';

import { ROUTE } from '@/constants/routes';

import { useAppSelector } from '@/hooks/redux';

import { selectLoggedInUser } from '@/redux/auth/selectors';
import { selectRightStartFeature } from '@/redux/configs';

export function MinorReviewCompletePage() {
  const navigate = useNavigate();
  const user = useAppSelector(selectLoggedInUser);
  const enabledRightStartAccount = useAppSelector(selectRightStartFeature);

  useEffect(() => {
    if (user && !enabledRightStartAccount) {
      navigate(ROUTE.MORE_INFORMATION, { replace: true });
    }
  }, [navigate, user, enabledRightStartAccount]);

  if (user && !enabledRightStartAccount) {
    return null;
  }

  return (
    <Page>
      <Box pb={12}>
        <MinorReviewCompleteForm />
      </Box>
    </Page>
  );
}

export default MinorReviewCompletePage;
